import { request } from 'root/common/request';
import config from '../../common/config/config';

/**
 * 获取城市列表
 */
export function getCityList(params) {
    return request({
        url: config.api.getCityList,
        method: 'GET',
        params: params,
        headers: {
            appId: 'wx9b3ada98e020c31b',
        },
    });
}

/**
 * 获取热门城市列表
 */
export function getHotCityList(params) {
    return request({
        url: config.api.getHotCityList,
        method: 'GET',
        params: params,
        headers: {
            appId: 'wx9b3ada98e020c31b',
        },
    });
}

/**
 * 获取城市列表
 */
export function getCityListV2(params) {
    return request({
        url: config.api.getCityListV2,
        method: 'GET',
        params: params,
        headers: {
            appId: 'wx9b3ada98e020c31b',
        },
    });
}

/**
 * 获取热门城市列表
 */
export function getHotCityListV2(params) {
    return request({
        url: config.api.getHotCityListV2,
        method: 'GET',
        params: params,
        headers: {
            appId: 'wx9b3ada98e020c31b',
        },
    });
}

/**
 * 根据经纬度获取城市
 */
export function getCityByPosition(params) {
    return request({
        url: config.api.getCityByPosition,
        method: 'GET',
        params: params,
        isNeedLoading: false,
        isNeedToken: false,
        headers: {
            // appId: 'wx9b3ada98e020c31b',
        },
    });
}
